import React from "react";
import { Button, TileTitle, TileSubtitle, Tile, TileBody, TileItem } from "aible";

import styles from "./style.module.css";

export default class CreateTile extends React.PureComponent {
  render() {
    const { onClick, isLoading, loadingText, buttonText, noPermissions, noPermissionsText, icon, img, children } =
      this.props;

    return (
      <Tile onClick={onClick && !noPermissions ? onClick : undefined} buttonText={buttonText} showButton isTileClick>
        <TileBody
          isLoading={isLoading}
          loadingText={loadingText}
          isError={noPermissions}
          errorText={noPermissionsText}
          showOnError
        >
          {(icon || img) && !children ? (
            <div className={styles.createTileIconWrapper}>
              <div className={styles.createTileIcon}>{img ? img : <img src={icon} alt={buttonText} />}</div>
            </div>
          ) : (
            children
          )}
        </TileBody>
      </Tile>
    );
  }
}
